"use client"

import { useEffect, useState } from "react"
import { usePathname } from 'next/navigation'

import { selectLanguage, toggleLanguage, selectUser, logoutUser } from "@/app/redux/store";
import { useDispatch, useSelector } from "react-redux"
import { findOneUserById } from "@/app/adapters/api";

import Image from 'next/image'
import Link from 'next/link'
import { Menu, ArrowRight, UserCircle, User, ChevronDown, X } from "lucide-react"
import logo from '@/app/assets/images/logo.svg'
import logoLBSGoparity from '@/app/assets/images/logo-bolsasocial-goparity.png'


type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[]
}

declare const window: WindowWithDataLayer

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import { Button } from "@/components/ui/button";
import { getPendingTransactionsByUserId, logout } from "@/app/adapters/api";

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"
import PendingInvestments from "../pending-investments/pendingInvestments";
import BreadcrumbsGeneral from "../breadCrumbsgeneral/breadcrumbsGeneral";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function WebHeader() {

  const dispatch = useDispatch()
  const pathname = usePathname()!
  const lang = useSelector(selectLanguage)
  const user = useSelector(selectUser)

  const [isOnTop, setIsOnTop] = useState(true)
  const [isOnImpactNetworkPage, setIsOnImpactNetworkPage] = useState(false)
  const [numberPendingInvestments, setNumberPendingInvestments] = useState(null)
  const [showPendingInvestments, setShowPendingInvestments] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", () =>
        setIsOnTop(window.pageYOffset < 20)
      )
    }
    const userStored = localStorage.getItem('user');

    if (userStored) {
      const user = JSON.parse(userStored);
      findOneUserById(user.id)
        .then((response) => {
          if (response.data.user.isOrizonMemberActive) {
            setIsOnImpactNetworkPage(true);
          }
        })
    }

    if (pathname.startsWith('/club-inversores-impact-network/') || pathname.startsWith('/impact-network-investor-club')) {
      setIsOnImpactNetworkPage(true);
    } else {
      setIsOnImpactNetworkPage(false);
    }
    if (user.isLogin) {
      getPendingTransactionsByUserId(user.id)
        .then((response: any) => {
          if (response.data.transactions.length > 0) {
            setNumberPendingInvestments(response.data.transactions.length)
          }
        })
        .finally(() => {
        })
    }
  }, [])

  const handleChangeLanguage = (newLang: string) => {
    try {
      dispatch(toggleLanguage())
      if (pathname === '/' && newLang === 'en') {
        window.location.href = `/?lang=en`;
      } else if (pathname === '/' && newLang === 'es') {
        window.location.href = pathname.replace('?lang=en', '');
      }
      if (pathname.includes('/nuestro-impacto/') && newLang === 'en') {
        window.location.href = `/our-impact`;
      } else if (pathname.includes('/our-impact/') && newLang === 'es') {
        window.location.href = '/nuestro-impacto'
      }
      if (pathname.includes('/contacto/') && newLang === 'en') {
        window.location.href = `/contact`;
      } else if (pathname.includes('/contact/') && newLang === 'es') {
        window.location.href = '/contacto'
      }
      if (pathname.includes('/registro') && newLang === 'en') {
        window.location.href = `/register`;
      } else if (pathname.includes('/register') && newLang === 'es') {
        window.location.href = '/registro'
      }
      if (pathname.includes('/entrar') && newLang === 'en') {
        window.location.href = `/login`;
      } else if (pathname.includes('/login') && newLang === 'es') {
        window.location.href = '/entrar'
      }
      if (pathname.includes('/mi-cuenta') && newLang === 'en') {
        window.location.href = `/my-account`;
      } else if (pathname.includes('/my-account') && newLang === 'es') {
        window.location.href = '/mi-cuenta'
      }
      if (pathname.includes('/quienes-somos/') && newLang === 'en') {
        window.location.href = `/about-us`;
      } else if (pathname.includes('/about-us/') && newLang === 'es') {
        window.location.href = '/quienes-somos'
      }
      if (pathname.includes('/productos-inversion/') && newLang === 'en') {
        window.location.href = `/investment-products`;
      } else if (pathname.includes('/investment-products/') && newLang === 'es') {
        window.location.href = '/productos-inversion'
      }
      if (pathname === '/productos-inversion/empresas-lending/' && newLang === 'en') {
        window.location.href = `/investment-products/lending`;
      } else if (pathname === '/investment-products/lending/' && newLang === 'es') {
        window.location.href = '/productos-inversion/empresas-lending'
      }
      if (pathname === '/productos-inversion/startup-equity/' && newLang === 'en') {
        window.location.href = `/investment-products/startup-equity`;
      } else if (pathname === '/investment-products/startup-equity/' && newLang === 'es') {
        window.location.href = '/productos-inversion/startup-equity'
      }
      if (pathname.includes('/oportunidades-inversion/') && newLang === 'en') {
        window.location.href = `/investment-opportunities`;
      } else if (pathname.includes('/investment-opportunities/') && newLang === 'es') {
        window.location.href = '/oportunidades-inversion';
      }
      if (pathname === '/club-inversores-impact-network/' && newLang === 'en') {
        window.location.href = `/impact-network-investor-club`;
      } else if (pathname === '/impact-network-investor-club/' && newLang === 'es') {
        window.location.href = '/club-inversores-impact-network';
      }
      if (pathname.includes('/club-inversores-impact-network/entrar') && newLang === 'en') {
        window.location.href = `/impact-network-investor-club/login/`;
      } else if (pathname.includes('/impact-network-investor-club/login/') && newLang === 'es') {
        window.location.href = '/club-inversores-impact-network/entrar';
      }
      if (pathname.includes('/club-inversores-impact-network/registro') && newLang === 'en') {
        window.location.href = `/impact-network-investor-club/register/`;
      } else if (pathname.includes('/impact-network-investor-club/register') && newLang === 'es') {
        window.location.href = '/club-inversores-impact-network/registro';
      }
      if (pathname.includes('/registro-emprendedor') && newLang === 'en') {
        window.location.href = `/investor-signup`;
      } else if (pathname.includes('/investor-signup') && newLang === 'es') {
        window.location.href = '/registro-emprendedor';
      }
      if (pathname.includes('/ejemplos-de-inversion') && newLang === 'en') {
        window.location.href = `/investment-examples`;
      } else if (pathname.includes('/investment-examples') && newLang === 'es') {
        window.location.href = '/ejemplos-de-inversion';
      }
      if (pathname.includes('/preguntas-frecuentes') && newLang === 'en') {
        window.location.href = `/faqs`;
      } else if (pathname.includes('/faqs') && newLang === 'es') {
        window.location.href = '/preguntas-frecuentes';
      }
      if (pathname.includes('/informacion-basica') && newLang === 'en') {
        window.location.href = `/basic-information`;
      } else if (pathname.includes('/basic-information') && newLang === 'es') {
        window.location.href = '/informacion-basica';
      }
      if (pathname.includes('/privacidad') && newLang === 'en') {
        window.location.href = `/privacy-policy`;
      } else if (pathname.includes('/privacy-policy') && newLang === 'es') {
        window.location.href = '/privacidad';
      }
      if (pathname.includes('/cookies') && newLang === 'en') {
        window.location.href = `/cookie-policy`;
      } else if (pathname.includes('/cookie-policy') && newLang === 'es') {
        window.location.href = '/cookies';
      }
      if (pathname.includes('/condiciones-contratacion') && newLang === 'en') {
        window.location.href = `/general-terms-and-conditions`;
      } else if (pathname.includes('/general-terms-and-conditions') && newLang === 'es') {
        window.location.href = '/condiciones-contratacion';
      }
      if (pathname.includes('/bienvenida') && newLang === 'en') {
        window.location.href = `/welcome`;
      } else if (pathname.includes('/bienvenida') && newLang === 'es') {
        window.location.href = '/welcome';
      }
    } catch (error) {
      console.log('Error cambiando idioma', error)
    }
  }

  const handleLogout = () => {
    logout().then((response: any) => {
      dispatch(logoutUser())
      window.location.href = '/'
    })
  }

  const handleShowPendingInvestments = () => {
    /* if (numberPendingInvestments && numberPendingInvestments > 0) { //FIX PENDING INVESTMENTS
      setShowPendingInvestments(!showPendingInvestments)
    } else { */
      window.location.href = '/mi-cuenta/'
    /* } */
  }

  const BANNER_KEY = "promoBannerDismissedUntil";
  const DISMISS_DAYS = 2; // number of days to hide

  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(BANNER_KEY);
    if (!stored) {
      setShowBanner(true);
      return;
    }

    const dismissedUntil = new Date(stored);
    const now = new Date();

    if (now > dismissedUntil) {
      setShowBanner(true); // expired → show again
    }
  }, []);

  const dismissBanner = () => {
    const now = new Date();
    now.setDate(now.getDate() + DISMISS_DAYS);
    localStorage.setItem(BANNER_KEY, now.toISOString());
    setShowBanner(false);
  };

  return (
    <header className={isOnTop ? 'fixed z-50 w-full h-auto text-base bg-transparent pt-2' : 'pt-2 fixed z-50 w-full h-auto text-base bg-white text-brownLBS shadow-md'}>
      <div className="flex flex-col gap-2"> 
          <div className="flex justify-between px-5">
              <Link href={lang === 'en'? '/?lang=en': '/'}>
                {
                  isOnImpactNetworkPage ?
                    <Image className='w-32' src={logoLBSGoparity} alt="logo" />
                    :
                    <Image className='w-32' src={logoLBSGoparity} alt="logo" />
                }
              </Link>
              <div className="flex items-center pt-4">
                {/* {
                  numberPendingInvestments && numberPendingInvestments > 0 ?
                    <div
                      onClick={() => handleShowPendingInvestments()}
                      className="lg:hidden bg-red-500 h-8 w-8 text-white text-xs flex justify-center items-center rounded-full mr-2 cursor-pointer">
                        {numberPendingInvestments} 
                    </div>
                    :
                    null
                } */}
                <div className="hidden lg:flex items-center">
                
                {/* QUIENES SOMOS */}
                <Link href={lang === 'en' ? "/about-us": "/quienes-somos/"}>
                    {
                      isOnImpactNetworkPage ?
                        <p className={`text-base mr-4 p-2 max-w-[180px] leading-tight text-center box-border hover:text-impact-green font-semibold flex items-center ${pathname === '/quienes-somos/' || pathname === '/about-us/' ? 'text-impact-green' : ''}`}>
                          {lang === 'en' ? 'ABOUT US' : 'CONÓCENOS'}
                        </p>
                        :
                        <p className={`text-base mr-4 p-2 max-w-[180px] leading-tight text-center box-border hover:text-primary flex items-center ${pathname === '/quienes-somos/ ' || pathname === '/about-us/' ? 'text-primary' : ''}`}>
                          {lang === 'en' ? 'ABOUT US' : 'CONÓCENOS'}
                        </p>
                      }
                  </Link>

                  {/* CÓMO INVERTIR */}
                  <Link href={lang === 'en' ? "/investment-products" : "/productos-inversion/"}>
                    <HoverCard openDelay={0}>
                      <HoverCardTrigger>
                        {
                          isOnImpactNetworkPage ?
                            <p className={`text-base mr-4 p-2 max-w-[180px] leading-tight text-center box-border hover:text-impact-green font-semibold flex items-center ${pathname === '/productos-inversion/' || pathname === '/investment-products/' ? 'text-impact-green' : ''}`}>
                              {lang === 'en' ? 'HOW IT WORKS' : 'CÓMO INVERTIR'} <ChevronDown className="h-8 w-8" />
                            </p>
                            :
                            <p className={`text-base mr-4 p-2 max-w-[180px] leading-tight text-center box-border hover:text-primary flex items-center ${pathname === '/productos-inversion/' || pathname === '/investment-products/' ? 'text-primary' : ''}`}>
                              {lang === 'en' ? 'HOW IT WORKS' : 'CÓMO INVERTIR'} <ChevronDown className="h-8 w-8" />
                            </p>
                        }
                      </HoverCardTrigger>
                      <HoverCardContent>
                        {
                          isOnImpactNetworkPage ?
                            <>
                              <Link href={lang === 'en' ? "/investment-products/startup-equity/" : "/productos-inversion/startup-equity/"}>
                                <p className={`p-2 text-base leading-tight text-center box-border hover:text-impact-green font-semibold`}>{lang === 'en' ? 'EQUITY INVESTMENTS' : 'INVERSIONES EN CAPITAL'}</p>
                              </Link>
                              <Link href={lang === 'en' ? "/investment-products/lending" : "/productos-inversion/empresas-lending/"}>
                                <p className={`p-2 text-base leading-tight text-center box-border hover:text-impact-green font-semibold`}>{lang === 'en' ? 'SUSTAINABLE LOANS' : 'PRÉSTAMOS SOSTENIBLES'}</p>
                              </Link>
                            </>
                            :
                            <>
                              <Link href={lang === 'en' ? "/investment-products/startup-equity/" : "/productos-inversion/startup-equity/"}>
                                <p className={`p-2 text-base leading-tight text-center box-border hover:text-primary`}>{lang === 'en' ? 'EQUITY INVESTMENTS' : 'INVERSIONES EN CAPITAL'}</p>
                              </Link>
                              <Link href={lang === 'en' ? "/investment-products/lending/" : "/productos-inversion/empresas-lending/"}>
                                <p className={`p-2 text-base leading-tight text-center box-border hover:text-primary`}>{lang === 'en' ? 'SUSTAINABLE LOANS' : 'PRÉSTAMOS SOSTENIBLES'}</p>
                              </Link>
                            </>
                        }
                      </HoverCardContent>
                    </HoverCard>
                  </Link>

                  {/* OPORTUNIDADES DE INVERSIÓN */}
                  {
                    isOnImpactNetworkPage ?
                      <Link href={lang === 'en' ? "/investment-opportunities" : "/oportunidades-inversion/"}>
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-impact-green font-semibold ${pathname === '/oportunidades-inversion/' || pathname === '/investment-opportunities/' ? 'text-impact-green' : ''}`}>{lang === 'en' ? 'INVESTMENT OPPORTUNITIES' : 'OPORTUNIDADES DE INVERSIÓN'}</p>
                      </Link>
                      :
                      <Link href={lang === 'en' ? "/investment-opportunities" : "/oportunidades-inversion/"}>
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-primary ${pathname === '/oportunidades-inversion/' || pathname === '/investment-opportunities/' ? 'text-primary' : ''}`}>{lang === 'en' ? 'INVESTMENT OPPORTUNITIES' : 'OPORTUNIDADES DE INVERSIÓN'}</p>
                      </Link>
                  }

                  {/* IMPACTO */}
                  {
                    isOnImpactNetworkPage ?
                      <Link href={lang === 'en' ? "/our-impact" : "/nuestro-impacto/"}>
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-impact-green font-semibold ${pathname === '/nuestro-impacto/' || pathname === '/our-impact/' ? 'text-impact-green' : ''}`}>{lang === 'en' ? 'IMPACT' : 'IMPACTO'}</p>
                      </Link>
                      :
                      <Link href={lang === 'en' ? "/our-impact" : "/nuestro-impacto/"}>
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-primary ${pathname === '/nuestro-impacto/' || pathname === '/our-impact/' ? 'text-primary' : ''}`}>{lang === 'en' ? 'IMPACT' : 'IMPACTO'}</p>
                      </Link>
                  }
                  {
                    isOnImpactNetworkPage ?
                      <Link href="/blog/">
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-impact-green font-semibold ${pathname === '/blog/' ? 'text-impact-green' : ''}`}>{lang === 'en' ? 'BLOG' : 'BLOG'}</p>
                      </Link>
                      :
                      <Link href="/blog/">
                        <p className={`text-base mr-4 p-2 max-w-[150px] leading-tight text-center box-border hover:text-primary ${pathname === '/blog/' ? 'text-primary' : ''}`}>{lang === 'en' ? 'BLOG' : 'BLOG'}</p>
                      </Link>
                  }
                  {
                    !user.isLogin ?
                      <>
                        {
                          isOnImpactNetworkPage ?
                            <>
                              <Link href={lang === 'en' ? "/impact-network-investor-club/login" : "/club-inversores-impact-network/entrar/"}>
                                <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'entrar' })} type="button" variant={"impactGreen"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Login' : 'Entrar'} </Button>
                              </Link>
                              {/* <Link href={lang === 'en' ? "/impact-network-investor-club/register" : "/club-inversores-impact-network/registro"}>
                                <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'registro-impact' })} type="button" variant={"impactBlack"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Signup' : 'Registro'} </Button>
                              </Link> */}
                              <Dialog>
                                <DialogTrigger>
                                  <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'entrar' })} type="button" variant={"impactGreen"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Login' : 'Entrar'} </Button>
                                </DialogTrigger>
                                <DialogContent>
                                  <DialogHeader>
                                    <DialogTitle>Are you absolutely sure?</DialogTitle>
                                    <DialogDescription>
                                      This action cannot be undone. This will permanently delete your account
                                      and remove your data from our servers.
                                    </DialogDescription>
                                  </DialogHeader>
                                </DialogContent>
                              </Dialog>
                            </>
                            :
                            <>
                             <Link href={lang === 'en' ? "/login" : "/entrar/"}>
                                <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'entrar' })} type="button" variant={"beige"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Login' : 'Entrar'} </Button>
                             </Link>
                             <Dialog>
                                <DialogTrigger>
                                  <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'registro' })} type="button" variant={"dark"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Signup' : 'Registro'} </Button>
                                </DialogTrigger>
                                <DialogContent className="sm:max-w-md text-center">
                                  <DialogHeader className="items-center gap-2 pt-2">
                                    <DialogTitle className="text-xl font-bold">Sigue invirtiendo en Goparity</DialogTitle>
                                    <DialogDescription className="text-base text-muted-foreground">
                                      El registro en Bolsa Social está cerrado. Puedes seguir invirtiendo con impacto a través de Goparity.
                                    </DialogDescription>
                                  </DialogHeader>
                                  <div className="flex justify-center pt-2 pb-4">
                                    <a href="https://goparity.com/es" target="_blank" rel="noopener noreferrer">
                                      <Button type="button" variant={"dark"} className="px-8 py-3 text-base uppercase tracking-wide">
                                        Ir a Goparity
                                      </Button>
                                    </a>
                                  </div>
                                </DialogContent>
                              </Dialog>
                             {/*  <Link href={lang === 'en' ? "/register" : "/registro/"}>
                                <Button onClick={() => window.dataLayer.push({ event: 'menu-cta', menuOpcion: 'registro' })} type="button" variant={"dark"} className="text-sm md:text-base py-2 px-4 md:px-6 uppercase mr-2"> {lang === 'en' ? 'Signup' : 'Registro'} </Button>
                              </Link> */}
                            </>
                        }
                      </>
                      :
                      <Button type="button"
                        variant={isOnImpactNetworkPage ? "impactGreen" : "customOutlineRounded"}
                        onClick={() => handleShowPendingInvestments()}
                        className="relative text-sm md:text-base py-2 pl-4 pr-8 md:pl-6 md:pr-8 uppercase mr-4">
                        <User className="mr-2 h-4 w-4" />
                        {user.name}
                        {/* {
                          numberPendingInvestments && numberPendingInvestments > 0 ?
                            <div className="absolute top-[-8px] right-[-6px] bg-red-500 h-8 w-8 text-white text-xs flex justify-center items-center rounded-full">
                              {numberPendingInvestments}
                            </div>
                            :
                            null 
                        } */}
                      </Button>
                  }
                </div>
                <Sheet>
                  <SheetTrigger>
                    {
                      isOnImpactNetworkPage ?
                        <div className="py-[4px] px-2 rounded bg-impact-green">
                          <Menu className="h-8 w-8 text-white" />
                        </div>
                        :
                        <div className="py-[4px] px-2 rounded bg-primary hover:bg-dark-primary">
                          <Menu className="h-8 w-8 text-white" />
                        </div>
                    }
                  </SheetTrigger>
                  <SheetContent>
                    <SheetHeader>
                      <SheetTitle>
                        {
                          user.isLogin ?
                            <div className="flex items-center mt-2">
                              <UserCircle size='32' strokeWidth='1' className="text-[#64748b]" />
                              <p className="hidden sm:block text-sm font-normal ml-2 text-[#64748b]">{user.name} {user.surname}</p>
                            </div>
                            :
                            <div className="flex items-center mt-[5px]">
                              <Link href={lang === 'en' ? "/login": "/entrar"}>
                                <Button type="button" variant={"beige"} className="py-2 px-6 uppercase mb-2 mr-2"> {lang === 'en' ? 'Login' : 'Entrar'} </Button>
                              </Link>
                            </div>
                        }
                      </SheetTitle>
                      <SheetDescription className="flex flex-col justify-between" style={{ height: 'calc(100vh - 5rem)' }}>
                        <div className="overflow-y-auto">
                          <div className="lg:hidden">
                            <Link href={lang === 'en' ? "/about-us": "/quienes-somos/"}>
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'ABOUT US' : 'CONÓCENOS'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                            <hr style={{ margin: '1rem auto' }} className='border-t border-gray' />
                            <Link href={lang === 'en' ? "/investment-opportunities" : "/oportunidades-inversion/"}>
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'INVESTMENT' : 'OPORTUNIDADES'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                            <hr style={{ margin: '1rem auto' }} className='border-t border-gray' />
                            <Link href="/ejemplos-de-inversion/">
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'PORTFOLIO' : 'PORFOLIO'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                            <hr style={{ margin: '1rem auto' }} className='border-t border-gray' />
                            <Link href={lang === 'en' ? "/investment-products": "/productos-inversion"}>
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'HOW IT WORKS' : 'CÓMO INVERTIR'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                            <hr style={{ margin: '1rem auto' }} className='border-t border-gray' />
                            <Link href="https://www.bolsasocial.com/blog/" target="_blank">
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'MEDIA' : 'ACTUALIDAD DE IMPACTO'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                            <hr style={{ margin: '1rem auto' }} className='border-t border-gray' />
                            <Link href={lang === 'en' ? "/contact": "/contacto/"}>
                              <p className="text-lg mt-4 flex justify-between items-center group">{lang === 'en' ? 'CONTACT' : 'CONTACTO'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                            </Link>
                          </div>
                          {
                            user.isLogin ?
                              <div className="bg-gray-200">
                                <Link href={lang === 'en' ? "/my-account": "/mi-cuenta/"}>
                                  <p className="text-lg mt-4 pt-4 px-4 flex justify-between items-center group">{lang === 'en' ? 'My account' : 'Mi cuenta'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                                </Link>
                                <hr style={{ margin: '1rem auto' }} className='border-t border-white' />
                                {
                                  user.role === 'admin' ?
                                    <>
                                      <Link href="/admin">
                                        <p className="text-lg mt-4 px-4 flex justify-between items-center group">Admin <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                                      </Link>
                                      <hr style={{ margin: '1rem auto' }} className='border-t border-white' />
                                    </>
                                    : null
                                }
                                <p onClick={handleLogout} className="text-lg mt-4 px-4 pb-4 flex justify-between items-center group cursor-pointer">{lang === 'en' ? 'Logout' : 'Cerrar sesión'} <ArrowRight className="ml-2 hidden group-hover:block" /></p>
                              </div>
                              :
                              null
                          }
                        </div>
                        <div className="flex flex-col justify-center items-center bg-white pt-4">
                          <Image className='w-32 mb-2' src={logo} alt="logo" />
                          <p>&copy; 2023</p>
                        </div>
                      </SheetDescription>
                    </SheetHeader>
                  </SheetContent>
                </Sheet>
                {
                  lang === 'es'
                    ?
                    <p onClick={() => handleChangeLanguage('en')} className={isOnImpactNetworkPage ? "text-base text-impact-green font-semibold ml-2 cursor-pointer" : "text-base text-lbs-secondary-orange font-semibold ml-2 cursor-pointer"}>EN</p>
                    :
                    <p onClick={() => handleChangeLanguage('es')} className={isOnImpactNetworkPage ? "text-base text-impact-green font-semibold ml-2 cursor-pointer" : "text-base text-lbs-secondary-orange font-semibold ml-2 cursor-pointer"}>ES</p>
                }
              </div>
          </div>
          
          {
            showPendingInvestments ?
              <PendingInvestments />
              :
              null
          }
          <BreadcrumbsGeneral 
              homeElement={'Home'}
              separator={<span>{'>'} </span>}
              containerClasses='flex -ml-10' 
              capitalizeLinks 
            />

          {showBanner && (
            <div className='w-full mx-auto px-0 relative'>
              <div className="absolute right-3 md:right-5 top-5 md:top-2 cursor-pointer font-semibold text-white z-10" onClick={dismissBanner}>
                <X/>
              </div>
              <div className="w-full bg-primary text-white font-semibold md:h-10 h-auto py-2 md:py-0 flex items-center justify-center px-6 text-sm leading-[1] md:text-lg">
                Bolsa Social <a href={"https://blog.bolsasocial.com/2026/01/13/%f0%9f%8c%b1-bolsa-social-y-goparity-un-nuevo-capitulo-para-hacer-crecer-la-inversion-de-impacto-en-iberia/"}><p className="text-white underline ml-1 mr-1">ya forma parte</p></a> de Goparity. Los nuevos registros se realizan en <a href="https://goparity.com/es" target="_blank" rel="noopener noreferrer" className="underline"><p className="text-white underline ml-1"> Goparity.com/es.</p></a>
                 
              </div>
            </div>
          )}
          
       </div>
      
    </header>
  )
}